// ConsultationPackage/ConsultationOrderPackagePicker.tsx
import React, {useEffect, useState} from 'react';
import {axios} from "Auth/axiosConfig";
import {useErrorProcessing} from "Core/components/ErrorProvider";
import {IConsultationConfig, IConsultationsPackage} from "../../Types/psychology/consultation";
import RadioLine from "Core/components/elements/RadioLine";
import pprint from '../../Utils/pprint';

export interface IPackagePickerProps {
    onPick: (pkg: IConsultationsPackage) => void;
    consultationConfig: IConsultationConfig;
}

const ConsultationOrderPackagePicker: React.FC<IPackagePickerProps> = (
    {
        onPick,
        consultationConfig
    }) => {
    const {byResponse} = useErrorProcessing();
    const [packages, setPackages] = useState<IConsultationsPackage[]>([]);
    const [selectedPackageId, setSelectedPackageId] = useState<number | string | null>(null);

    useEffect(() => {
        axios.get(`/api/v1/consultations/packages/?config=${consultationConfig.id}`)
            .then(response => {
                const fetchedPackages: IConsultationsPackage[] = response.data;
                setPackages(fetchedPackages);
                pprint('fetchedPackages')
                pprint(fetchedPackages)
                // Автоматически выбираем первый подходящий пакет, если он есть
                const firstFilteredPackage = fetchedPackages.find((pkg: IConsultationsPackage) =>
                    pkg.consultation_config.id === consultationConfig.id
                );

                if (firstFilteredPackage) {
                    setSelectedPackageId(firstFilteredPackage.id);
                    onPick(firstFilteredPackage);
                }
            })
            .catch(error => byResponse(error));
    }, [byResponse, consultationConfig, onPick]);

    const handlePackageClick = (pkgId: string | number) => {
        const selectedPkg = packages.find((pkg: IConsultationsPackage) => pkg.id === pkgId);
        if (selectedPkg) {
            setSelectedPackageId(pkgId);
            onPick(selectedPkg);
        }
    };

    const filteredPackages = packages.filter((pkg: IConsultationsPackage) =>
        pkg.consultation_config.id === consultationConfig.id
    );

    return (
        <div className={'fc gap-1'}>
            <span>Количество консультаций</span>
            <RadioLine
                itemClass={'flex-grow-1'}
                className={'w-100'}
                options={filteredPackages.map(pkg => ({value: pkg.id, label: pkg.consultation_count}))}
                selectedValue={selectedPackageId}
                onChange={handlePackageClick}
            />
        </div>
    );
};

export default ConsultationOrderPackagePicker;
